import RecentList from "./RecentList";
import React from "react";
export default function NoQuery({ recent, onClearRecent, onSelectRecentItem, }) {
    if (!recent.length)
        return null;
    return (<RecentList items={recent} onClear={onClearRecent} onSelectItem={onSelectRecentItem}/>);
}
